import { useEffect, useRef } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';

/**
 * useServerEvents — subscribes to the backend SSE stream.
 * @param {object} handlers - { onTaskCreated, onTaskUpdated, onCommentUpdated }
 * @param {string} token    - JWT auth token
 */
export default function useServerEvents(handlers, token) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!token) return;

    const es = new EventSource(`${API}/events?token=${token}`);

    es.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        const h = handlersRef.current;
        if (data.type === 'TASK_CREATED'      && h.onTaskCreated)      h.onTaskCreated(data);
        if (data.type === 'TASK_UPDATED'      && h.onTaskUpdated)      h.onTaskUpdated(data);
        // Sprint 4: COMMENT_UPDATED replaces DISCUSSION_UPDATED
        if (data.type === 'COMMENT_UPDATED'   && h.onCommentUpdated)   h.onCommentUpdated(data);
        // Keep legacy handler for backward compat during transition
        if (data.type === 'DISCUSSION_UPDATED' && h.onDiscussionUpdated) h.onDiscussionUpdated(data);
        if (data.type === 'DISCUSSION_UPDATED' && h.onCommentUpdated)   h.onCommentUpdated(data);
      } catch (_) {}
    };

    es.onerror = () => es.close();

    return () => es.close();
  }, [token]);
}
